
const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export const fetchWithRetry = async <T>(
  fetchFn: () => Promise<T>,
  maxRetries: number = 2,
  baseDelay: number = 1000
): Promise<T> => {
  let lastError: any;
  
  for (let attempt = 0; attempt <= maxRetries; attempt++) {
    try {
      return await fetchFn();
    } catch (error) {
      lastError = error;
      
      if (attempt === maxRetries) {
        break;
      }
      
      const delayTime = baseDelay * Math.pow(1.5, attempt);
      console.log(`Retry attempt ${attempt + 1} after ${delayTime}ms`);
      await delay(delayTime);
    }
  }
  
  throw lastError;
};
